import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, EmailField } from 'react-admin';

import App from '../../../../app.js';

const BalanceField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [balance, setBalance] = useState(record.balance);

	useEffect(() => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		mvcmydashboard.getCurrentSession()
		.then(sessionuuid => {
			return mvcmydashboard.getAccountBalance(sessionuuid, record.uuid);
		})
		.then(balance => {
			setBalance(balance + ' ETH');
		})
		.catch(err => {});

		return () => {
		};
	}, [props.balance]);

	return (
		<div>
			{balance}
		</div>
	);
};

BalanceField.defaultProps = { label: 'Balance' };

export const AccountList = props => (
	<List {...props} bulkActionButtons={false} >
		<Datagrid rowClick="show">
			<TextField source="address" />
			<TextField source="type" />
			<TextField source="origin" />
			<TextField source="description" />
			<BalanceField />
		</Datagrid>
	</List>
);